import { Typography } from "PFComponents/typography";
import React from "react";

import css from "../../dates.module.scss";

type WeekDayNameProps = {
  dayName: string;
  isDisabled: boolean;
};

export const WeekDayName = ({ dayName, isDisabled }: WeekDayNameProps): JSX.Element => (
  <Typography variant={isDisabled ? "bodyRegular" : "bodyBold"} tag="span" className={css.weekDayLabel2}>
    {dayName}
  </Typography>
);
